import React, { useState, useEffect } from 'react';
import './SegmentedDisplay.css';
import img00 from '../assets/img00.jpg';
import img01 from '../assets/img01.jpg';
import img02 from '../assets/img02.jpg';
import img03 from '../assets/img03.jpg';
import img04 from '../assets/img04.jpg';
import img05 from '../assets/img05.jpg';
import img06 from '../assets/img06.jpg';
import img07 from '../assets/img07.jpg';
import img08 from '../assets/img08.jpg';
import img09 from '../assets/img09.jpg';
import img10 from '../assets/img10.jpg';
import img11 from '../assets/img11.jpg';
import img12 from '../assets/img12.jpg';
import img13 from '../assets/img13.jpg';
import img14 from '../assets/img14.jpg';
import img15 from '../assets/img15.jpg';
import img16 from '../assets/img16.jpg';
import img17 from '../assets/img17.jpg';
import img18 from '../assets/img18.jpg';
import img19 from '../assets/img19.jpg';
import img20 from '../assets/img20.jpg';
import img21 from '../assets/img21.jpg';
import img22 from '../assets/img22.jpg';
import img23 from '../assets/img23.jpg';
import img24 from '../assets/img24.jpg';
import img25 from '../assets/img25.jpg';
import img26 from '../assets/img26.jpg';
import img27 from '../assets/img27.jpg';
import img28 from '../assets/img28.jpg';
import img29 from '../assets/img29.jpg';
import img30 from '../assets/img30.jpg';
import img31 from '../assets/img31.jpg';
import img32 from '../assets/img32.jpg';
import img33 from '../assets/img33.jpg';
import img34 from '../assets/img34.jpg';
import img35 from '../assets/img35.jpg';

const buttonData = [
    {
        id: 1,
        title: 'Community Soup Kitchen Initiative',
        images: [img00, img01],
        description: 'Our soup kitchen served as more than just a place to get food. It became a safe, welcoming environment where people could come together, share stories, and feel a sense of belonging. We fostered a spirit of collaboration, not just between volunteers and beneficiaries, but also among local businesses and other charitable organizations. This collective effort strengthened the social fabric of the community.',
    },
    {
        id: 2,
        title: 'Youth Crime Prevention : Prayer March',
        images: [img02, img03],
        description: 'We partnered with various church ministries and the South African Police Department to lead a prayer march that brought together community members, religious leaders, law enforcement, and volunteers. This collaboration emphasized the importance of faith, community support, and law enforcement in tackling youth crime. To ensure meaningful impact, we actively involved youth groups, community leaders, and local schools. Civilians had the opportunity to participate in the march , making their voices heard in the fight against crime. This empowers people as agents of change within their communities.',
    },
    {
        id: 3,
        title: 'Tire Recycling Initiative for Youth Empowerment',
        images: [img04, img05, img06, img07, img08, img09, img10, img11, img12, img13, img14, img15, img16, img17] ,
        description: 'South African Youth in Arts has launched a tire recycling initiative in partnership with merSETA (Manufacturing, Engineering, and Related Services Sector Education and Training Authority) to create jobs and support sustainable mining. This project aligns with merSETA goals of greening, recycling, refurbishment, and manufacturing, generating employment in repair, maintenance, and products like rubber bricks and playground surfaces. It empowers youth through skills development and training in machinery operation while promoting entrepreneurship in the green economy. Collaborating with schools, universities, and the University of Johannesburg, this initiative aims to foster a sustainable future for South Africa’s youth and drive positive community change.',
    },
    {
        id: 4,
        title: 'Empowering Youth Through Arts and Skills Development',
        images: [img18, img19, img20, img21, img22, img23, img24, img25, img26, img27, img28, img29, img30],
        description: 'South African Youth in Arts (SAYIA) empowers youth through arts, skills development, and community outreach programs. Our CSI/Outreach Programs offer arts education with training in disadvantaged communities, youth development through mentorship and career guidance, and community engagement by partnering with local organizations for social cohesion. We provide skills development in mining-related areas like repair and machinery operation and support entrepreneurship with business skills training for young entrepreneurs. SAYIA collaborates with merSETA, ETDP Seta, Services Seta, Correctional Services, over 20 NGOs, and youth organizations to promote youth empowerment, social cohesion, economic growth, and address social and economic challenges facing South African youth.',
    },
    {
        id: 5,
        title: 'Sports Against Crime: Community Activities',
        images: [img31, img32],
        description: 'The Sports Against Crime initiative took place at Malvern Primary School, where we partnered with the Youth Crime Prevention Forum and local police to engage the community in meaningful activities. The event featured speakers who raised awareness about crime prevention, emphasizing the importance of community involvement. To promote teamwork and healthy competition, the day culminated in a soccer tournament and a netball tournament, where participants competed for prizes, including goodies and medals. This initiative not only fostered community spirit but also highlighted the role of sports in promoting safety and unity among youth.',
    },
    {
        id: 6,
        title: 'Community Donations for Preschools and Childrens Homes',
        images: [img33, img34, img35],
        description: 'The 67 Minutes initiative is our annual commemoration of Nelson Mandela Day, where we dedicate time to positively impact the community. This year, we focused on donating supplies and resources to local preschools and children’s homes. By engaging volunteers and community members, we gathered essential items such as books, toys, clothing, and educational materials. This initiative aims to enhance the learning environment for young children and support those in need, embodying the Mandela legacy of compassion and community service. Through these efforts, we foster a spirit of giving and social responsibility within our community.',
    },
];

const SegmentedDisplay = () => {
    const [selectedButton, setSelectedButton] = useState(buttonData[0]);
    const [currentSlide, setCurrentSlide] = useState(0);

    const handleButtonClick = (buttonId) => {
        const selected = buttonData.find((button) => button.id === buttonId);
        setSelectedButton(selected);
        setCurrentSlide(0); // Reset the slide index when switching buttons
    };

    // Automated slider effect
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prevSlide) =>
                prevSlide === selectedButton.images.length - 1 ? 0 : prevSlide + 1
            );
        }, 3000); // Slide every 3 seconds
        return () => clearInterval(interval); // Cleanup on component unmount
    }, [selectedButton]);

    return (
        <div className="unique-container">
            {/* First sub-div: Buttons */}
            <div className="unique-buttons-container">
                {buttonData.map((button) => (
                    <button
                        key={button.id}
                        className={`unique-square-button ${selectedButton.id === button.id ? 'unique-active' : ''}`}
                        onClick={() => handleButtonClick(button.id)}
                    >
                        {button.title}
                    </button>
                ))}
            </div>

            {/* Second sub-div: Display area */}
            <div className="unique-display-container">
                <h2>{selectedButton.title}</h2>

                <div className="unique-content">
                    {/* Image slider */}
                    <div className="unique-image-slider">
                        <img
                            src={selectedButton.images[currentSlide]}
                            alt={`Slide ${currentSlide + 1}`}
                        />
                    </div>

                    {/* Description */}
                    <div className="unique-description">
                        <p>{selectedButton.description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SegmentedDisplay;
